import { FilterSelectionState } from '../../../filters/selection/FilterSelectionState';
import { FilterKey } from '@studyportals/search-filters';
import { SearchOrganisationPresenter } from '../../../presenters/SearchOrganisationPresenter';
import { FilterOptions } from '@/filters/options/FilterOptions';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export class University extends SeoHeadingHandlerDefaultSorting {

	private readonly organisationPresenter: SearchOrganisationPresenter;

	public constructor(filterOptions: FilterOptions, organisationPresenter: SearchOrganisationPresenter) {
		super(filterOptions);

		this.organisationPresenter = organisationPresenter;
	}

	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return await this.singleSelectionFor(FilterKey.ORGANISATIONS, filterSelectionState);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const idOfOrganisation = this.getFilterOptionValueBy(FilterKey.ORGANISATIONS, filterSelectionState);
		if (idOfOrganisation === null) {
			return this.createSeoInfoDefault();
		}
		return await this.createSeoInfoForOrganisation(idOfOrganisation);
	}

	private createSeoInfoDefault(): string {
		return `Find out more about the university`;
	}

	private async createSeoInfoForOrganisation(idOfOrganisation: string): Promise<string> {
		const university = await this.organisationPresenter.retrieve(idOfOrganisation);
		if (university === null) {
			return this.createSeoInfoDefault();
		}

		return this.createSeoInfo(university.name);
	}

	private async createSeoInfo(university: string): Promise<string> {
		return Promise.resolve(`Find out more about ${university}`);
	}
}
